export var X_FIELD = 'x';
export var Y_FIELD = 'y';
export var NODE_COLOR_FIELD = 'name';
export var EDGE_COLOR_FIELD = 'source';
export var DEFAULT_OPTIONS = {
  nodeStyle: {
    opacity: 1,
    fillOpacity: 1,
    lineWidth: 1
  },
  edgeStyle: {
    opacity: 0.5,
    lineWidth: 2
  },
  label: {
    fields: ['x', 'name'],
    callback: function callback(x, name) {
      var centerX = (x[0] + x[1]) / 2;
      var offsetX = centerX > 0.5 ? -4 : 4;
      return {
        labelEmit: true,
        style: {
          fill: '#8c8c8c'
        },
        offsetX: offsetX,
        content: name
      };
    }
  },
  tooltip: {
    fields: ['source', 'target', 'value'],
    formatter: function formatter(datum) {
      var source = datum.source,
          target = datum.target,
          value = datum.value;
      return {
        name: source + " -> " + target,
        value: value
      };
    }
  },
  interactions: [{
    type: 'element-active'
  }],
  weight: true,
  nodePaddingRatio: 0.1,
  nodeWidthRatio: 0.05
};